export default __webpack_public_path__ + "static/media/linkedin.7b079f88.svg";